<template>
	<Col class="dashboard-container height-100 width-100">
		<AnalyticsDashboardRightSideTopSection smallScreenLayout class="half-top-right-side width-100 mb-5" />
		<Row class="flex-justify-center">
			<AnalyticsDashboardMainContent class="main-container width-100" />
			<Col class="divider height-100" />
			<AnalyticsDashboardRightSide class="right-side-container" />
		</Row>
		<AnalyticsLatestErrorsCard class="half-bottom-right-side width-100 mt-5" />
		<Col class="width-100 spacer" />
	</Col>
</template>
<script>
import AnalyticsLatestErrorsCard from '@/components/Analytics/Cards/AnalyticsLatestErrorsCard.vue';
import AnalyticsDashboardRightSide from '@/components/Analytics/Dashboard/AnalyticsDashboardRightSide.vue';
import AnalyticsDashboardMainContent from '@/components/Analytics/Dashboard/AnalyticsDashboardMainContent.vue';
import AnalyticsDashboardRightSideTopSection from '@/components/Analytics/Dashboard/RightSide/AnalyticsDashboardRightSideTopSection.vue';
export default {
	name: 'AnalyticsDashboard',
	components: {
		AnalyticsLatestErrorsCard,
		AnalyticsDashboardRightSide,
		AnalyticsDashboardMainContent,
		AnalyticsDashboardRightSideTopSection,
	},
};
</script>
<style scoped lang="scss">
$sides-divider-width: 20px;
$right-side-min-width: 345px;
$right-side-max-width: 345px;
$main-section-max-width: 1100px;

.main-container {
	width: 100%;
	max-width: $main-section-max-width;
}
.right-side-container {
	min-width: $right-side-min-width;
	max-width: $right-side-max-width;
}
.divider {
	width: $sides-divider-width;
}

.dashboard-container[min-width~='1110px'] {
	// full dashboard - big screen
	.divider,
	.right-side-container {
		display: flex;
	}
	.half-top-right-side,
	.half-bottom-right-side {
		display: none;
	}
	@media (max-height: 1010px) {
		.spacer {
			display: flex;
		}
	}
}
.dashboard-container[max-width~='1110px'] {
	// collapsed dashboard - small screen
	.divider,
	.right-side-container {
		display: none;
	}
	.spacer,
	.half-top-right-side,
	.half-bottom-right-side {
		display: flex;
	}
}

.spacer {
	display: none;
	min-height: $sides-divider-width;
}
</style>
